<template>
  <div>
    <div style="display: flex;justify-content: space-between;">
      <div style="display: flex;">
        <div style="margin-top:15px">效果图:</div>
        <img
          :src="peitu"
          width="50px"
          @click="dialogVisible = true"
          height="50px"
        />
        <el-dialog title="效果图" :visible.sync="dialogVisible">
          <img :src="peitu" width="100%" height="100%" />
        </el-dialog>
      </div>
      <el-button
        type="primary"
        style="display:flex;border-radius: 10px 10px 0px 0px;"
        @click="add()"
        >添加</el-button
      >
    </div>
    <el-table type="index" :data="data" style="width: 100%" border stripe>
      <el-table-column label="产品名称" align="center" prop="productName">
        <template slot-scope="scope">
          <el-input
            disabled
            v-model="data[scope.$index].productName"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="产品链接" align="center" prop="productUrl">
        <template slot-scope="scope">
          <el-input disabled v-model="data[scope.$index].productUrl"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200px">
        <template slot-scope="scope" style="display: flex; ">
          <el-button type="text" @click="deleteRow(scope.$index)"
            >删除</el-button
          >
          <more
            :postId="data[scope.$index]"
            @dataReturn="dataReturn(scope.$index, arguments)"
          ></more>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import more from "./more";
export default {
  data() {
    return {
      dialogVisible: false,
      expands: [false],
      data: [{}],
      curImg: 0,
      peitu: require("@/assets/logo.png")
    };
  },
  props: {
    openModule: {
      default: []
    }
  },
  components: {
    more
  },
  mounted() {
    this.getMassage();
  },
  watch: {
    data: {
      handler(val) {
        console.log("33333333333333333", val);
        this.$emit("getModule", val);
      },
      deep: true
    },
    openModule: {
      handler(val) {
        console.log("1`23123321", val);
        this.getMassage();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    dataReturn(index, arg) {
      console.log(index);
      this.data[index] = arg[0];
      console.log(arg);
      console.log(this.data);
    },
    getMassage() {
      if (this.openModule) {
        this.data = this.openModule;
      }
    },
    // 折叠面板每次只能展开一行
    // expandSelect(row, expandedRows) {
    //   var that = this;
    //   if (expandedRows.length) {
    //     that.expands = [];
    //     if (row) {
    //       that.expands.push(row);
    //     }
    //     this.$refs.tableData.toggleRowExpansion(expandedRows[0]);
    //   } else {
    //     that.expands = [];
    //   }
    //   // console.log(that.expands)
    // },
    // 删除整条信息
    deleteRow(index) {
      this.data.splice(index, 1);
    },
    // 添加一条信息
    add() {
      this.data.push({
        productImg: "",
        productCode: "",
        productLogo: "",
        productName: "",
        productUrl: "",
        id: "",
        productIntroduction: ""
      });
    },
    changeCur(index) {
      this.curImg = index;
      console.log(this.curImg);
    }
  }
};
</script>

<style lang="sass">
.flex
  display: flex
  text-align: center
.avatar-uploader .el-upload
  border: 1px dashed #d9d9d9
  border-radius: 6px
  cursor: pointer
  position: relative
  overflow: hidden
  .avatar-uploader .el-upload:hover
    border-color: #409EFF
  .avatar-uploader-icon
    font-size: 28px
    color: #8c939d
    width: 178px
    height: 178px
    line-height: 178px
    text-align: center
  .avatar
    width: 178px
    height: 178px
    display: block
</style>
